// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:25
import { SimpleCallCard_abstract } from './../abstract/SagaSchema/SimpleCallCard_abstract';
export class SimpleCallCard extends SimpleCallCard_abstract {}
